//frontend/src/hooks/useRouteData.js

import { useState, useEffect } from 'react';
import { useRegion } from '../contexts/RegionContext';

export function useRouteData() {
  const { adapter } = useRegion();
  const [routes, setRoutes] = useState([]);
  const [selectedRouteId, setSelectedRouteId] = useState(null);
  const [stops, setStops] = useState({ outbound: [], inbound: [] });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadRoutes = async () => {
      try {
        const opts = await adapter.fetchRouteOptions();
        setRoutes(opts);
        if (opts.length) setSelectedRouteId(opts[0].id);
      } catch (err) {
        setError(err.message);
      }
    };
    loadRoutes();
  }, [adapter]);

  useEffect(() => {
    if (!selectedRouteId) return;
    const loadStops = async () => {
      setLoading(true);
      setError(null);
      try {
        const data = await adapter.fetchRouteStops(selectedRouteId);
        setStops({
          outbound: data.outbound ?? [],
          inbound: data.inbound ?? [],
        });
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    loadStops();
  }, [selectedRouteId, adapter]);

  return { routes, selectedRouteId, setSelectedRouteId, stops, loading, error };
}